module.exports = __webpack_public_path__ + "static/media/vnws-2022.93abc1cb.jpeg";